import useTranslation from 'next-translate/useTranslation'

import RuleBottomItem from '@/molecules/RuleBottomItem'
import RuleItem from '@/molecules/RuleItem'

function Rules() {
  const { t } = useTranslation('wellBeing')

  return (
    <div className="flex flex-col items-center justify-center w-full p-4 md:p-16 bg-gradient-to-r from-violet-25 to-violet-50">
      <h4 className="mt-5 text-3xl italic font-black text-white uppercase 2md:text-5xl 2sm:text-4xl md:text-5xl">
        {t('rules_title')}
      </h4>
      <div className="flex p-4 my-12 bg-white md:p-16 rounded-5xl">
        <div className="grid grid-cols-1 xs:grid-cols-2 md:gap-2 xl:grid-cols-4">
          <RuleItem
            title="rules_title_1"
            copy="rules_copy_1_1"
            image="rules-1"
            first="rules_copy_1_2"
          />
          <RuleItem title="rules_title_2" copy="rules_copy_2" image="rules-2" />
          <RuleItem title="rules_title_3" copy="rules_copy_3" image="rules-3" />
          <RuleItem title="rules_title_4" copy="rules_copy_4" image="rules-4" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center mt-24 md:flex-row">
        <RuleBottomItem copy="rules_bottom_1" image="rules-bottom-1" />
        <RuleBottomItem copy="rules_bottom_2" image="rules-bottom-2" />
      </div>
    </div>
  )
}

export default Rules
